import React, { useEffect, useState } from 'react';
import { api } from '../../api/client';

interface ChatAnalytics {
  abertos: number;
  analisando: number;
  pendentes: number;
  arrumando: number;
  teste: number;
  resolvidos: number;
  slaVencido: number;
  urgentes: number;
  tempoMedioRespostaMin?: number;
  tempoMedioResolucaoMin?: number;
}

const cards: Array<{ key: keyof ChatAnalytics; label: string }> = [
  { key: 'abertos', label: 'Abertos' },
  { key: 'analisando', label: 'Analisando' },
  { key: 'pendentes', label: 'Pendentes' },
  { key: 'arrumando', label: 'Arrumando' },
  { key: 'teste', label: 'Em teste' },
  { key: 'resolvidos', label: 'Resolvidos' },
  { key: 'slaVencido', label: 'SLA vencido' },
  { key: 'urgentes', label: 'Urgentes' },
];

export function ChatOperationsDashboard() {
  const [data, setData] = useState<ChatAnalytics | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    api.get('/chat-interno/analytics')
      .then((res) => setData(res.data))
      .finally(() => setLoading(false));
  }, []);

  if (loading && !data) {
    return <div className="p-4 text-sm text-muted-foreground">Carregando indicadores do chat...</div>;
  }

  if (!data) {
    return <div className="p-4 text-sm text-muted-foreground">Sem dados de atendimento.</div>;
  }

  return (
    <div className="grid gap-3 md:grid-cols-4">
      {cards.map((card) => (
        <div key={card.key} className="rounded-xl border bg-card p-4 shadow-sm">
          <p className="text-xs font-bold uppercase tracking-wide text-muted-foreground">{card.label}</p>
          <h3 className="mt-2 text-2xl font-black text-foreground">{Number(data[card.key] || 0)}</h3>
        </div>
      ))}
      <div className="rounded-xl border bg-card p-4 shadow-sm md:col-span-2">
        <p className="text-xs font-bold uppercase tracking-wide text-muted-foreground">Tempo médio de resposta</p>
        <h3 className="mt-2 text-2xl font-black text-foreground">{data.tempoMedioRespostaMin || 0} min</h3>
      </div>
      <div className="rounded-xl border bg-card p-4 shadow-sm md:col-span-2">
        <p className="text-xs font-bold uppercase tracking-wide text-muted-foreground">Tempo médio de resolução</p>
        <h3 className="mt-2 text-2xl font-black text-foreground">{data.tempoMedioResolucaoMin || 0} min</h3>
      </div>
    </div>
  );
}
